import React from "react";
import "./Tabs.css";

/**
 * Simple tab switcher used by the Phase 8 finance pages to fold several old
 * digicampusbd pages (e.g. fee subhead/amount/time configuration) into one
 * new page — same underlying resources, fewer routes.
 * `tabs` = [{ key, label }], `active` = current key, `onChange(key)`.
 */
export default function Tabs({ tabs, active, onChange }) {
  return (
    <div className="tabs-bar">
      {tabs.map((t) => (
        <button
          key={t.key}
          type="button"
          className={`tab-btn ${active === t.key ? "active" : ""}`}
          onClick={() => onChange(t.key)}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
